import AccessGuardLayout from '~/components/layouts/AccessGuardLayout';
import AccelerateBuying from '~/images/planGates/accelerate_buying.svg';
import OptimizePerformance from '~/images/planGates/optimize_performance.svg';
import Tile from '~/images/Tiles/Enrichment.svg';
import history from '~/lib/history';
import paths from '~/lib/paths';

export default function EnrichmentAccess() {
  return (
    <AccessGuardLayout
      title="Data sync"
      description="Get rich firmographic data into the systems that matter most to your business."
      tile={<Tile />}
      onRequestAccess={() => {
        history.push(paths.dataEnrichmentAccessRequest());
      }}
      featureCallouts={[
        {
          name: 'Accelerate the buying process',
          description:
            'Create a better buying experience and turn inquiries into revenue with real-time data for scoring, routing, and selling.',
          image: <AccelerateBuying />,
        },
        {
          name: 'Optimize your go-to-market performance',
          description:
            'Uncover performance-boosting insights hiding in your marketing and sales data.',
          image: <OptimizePerformance />,
        },
      ]}
      testimonial={{
        quote:
          'Our best fit prospects now get a frictionless buyer experience and a fast-track to become raving fans.',
        customerName: 'Russell Banzon',
        customerTitle: 'Senior Director, Marketing, Gong',
        url: 'https://clearbit.com/blog/gong-io-instant-lead-qualification',
      }}
    />
  );
}
